module.exports = __webpack_public_path__ + "static/choose-logo-2ea2c77857e44b4d7ea4f2694ea42764.png";